import React from 'react';
import { connect, ResolveThunks } from 'react-redux';
import { SxProps, Theme } from '@mui/material';

import { PropertyTextInput } from '@paragon/client-tools';
import { ExplicitCalculatedLine } from '@paragon/relative-geometry';

import { findAndSetReferenceLine } from '../../../../store/actions/editorActions';

interface OwnProps {
  line: ExplicitCalculatedLine;
  disabled?: boolean;
  sx?: SxProps<Theme>;
}

type DispatchProps = ResolveThunks<typeof actionCreators>;

type Props = OwnProps & DispatchProps;

class ReferenceLineNameProperty extends React.Component<Props> {
  onChangeLineName = (newName: string) => {
    if (newName !== this.props.line.name) {
      this.props.setReferenceLine({ ...this.props.line, name: newName });
    }
  };

  render() {
    return (
      <PropertyTextInput
        fullWidth
        sx={this.props.sx}
        property="Name"
        value={this.props.line.name}
        submit={this.onChangeLineName}
        disabled={this.props.disabled}
      />
    );
  }
}

const actionCreators = { setReferenceLine: findAndSetReferenceLine };

export default connect(null, actionCreators)(ReferenceLineNameProperty);
